/*
 * Copyright (c) 2021-2024. StockAnywhere CC
 * StockAnywhere - https://www.stockanywhere.io
 * View license agreement and terms of use at https://www.stockanywhere.io/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2024-06-30
 */

import React from "react";

export const SpinnerLoading = (props: {text?: string}) => {
    return(
        <>
            <div className="container m-5 d-flex justify-content-center" style={{  }}>
                <div className="spinner-border text-danger" role="status">
                    <span className="visually-hidden">
                        
                    </span>
                </div>
            </div>
            <div className="container m-5 d-flex justify-content-center" >
                <div className="text-dark" >
                {props.text}
                </div>
            </div>            
        </>
    );
}